// extracted by mini-css-extract-plugin
export default {"todoBody":"TodoPage_todoBody__A9PO4"};